import React, { createContext, useMemo, FC, ReactNode } from "react";
import { useGetCommonTranslations } from "../hooks/useGetCommonTranslations";
import { Spinner } from "../../../Atoms/Spinner/Spinner";

export const TranslationContext = createContext({});

export const TranslationContextProvider: FC<React.PropsWithChildren<{ children: ReactNode }>> = ({
  children,
}) => {
  const { data: commonTranslations, isLoading } = useGetCommonTranslations();

  const translations = useMemo(
    () => ({
      common: commonTranslations,
    }),
    [commonTranslations]
  );

  return (
    <TranslationContext.Provider value={translations}>
      {isLoading ? <Spinner /> : children}
    </TranslationContext.Provider>
  );
};
